import { apiErrorSchema } from "../../../shared/labels/contracts";
import { labelPinAdminStatusSchema, labelPinAssignmentSchema } from "../../../shared/labels/pin-contracts";

class LabelPinAdminError extends Error {}

async function request(userId: string, action: "status" | "credential", input?: { pin: string; expectedVersion: number; sendEmail: boolean }, signal?: AbortSignal) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal?.aborted) controller.abort();
  signal?.addEventListener("abort", abort, { once: true });
  const timeout = setTimeout(abort, 15_000);
  try {
    const response = await fetch(`/api/labels/pin/admin/users/${encodeURIComponent(userId)}${action === "status" ? "" : "/credential"}`, {
      method: action === "status" ? "GET" : "PUT", credentials: "same-origin", cache: "no-store", signal: controller.signal,
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: action === "status" ? undefined : JSON.stringify(input),
    });
    const payload: unknown = await response.json().catch(() => null);
    if (!response.ok) {
      const fault = apiErrorSchema.safeParse(payload);
      throw new LabelPinAdminError(fault.success ? fault.data.error.message : "Etiket PIN işlemi tamamlanamadı. Durumu yenileyin.");
    }
    return payload;
  } catch (cause: unknown) {
    if (cause instanceof LabelPinAdminError) throw cause;
    throw new LabelPinAdminError("PIN işleminin sonucu doğrulanamadı. Yeni davet oluşturmadan önce durumu yenileyin.", { cause });
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener("abort", abort);
  }
}

export const labelPinAdminApi = {
  status: async (userId: string, signal?: AbortSignal) => labelPinAdminStatusSchema.parse(await request(userId, "status", undefined, signal)),
  setCredential: async (userId: string, input: { pin: string; expectedVersion: number; sendEmail: boolean }, signal?: AbortSignal) =>
    labelPinAssignmentSchema.parse(await request(userId, "credential", input, signal)),
};
